import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturedSection from './components/FeaturedSection';
import ReviewSection from './components/ReviewSection';
import CTASection from './components/CTASection';

const jsonLdWebSite = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '韩漫漫画网站',
  alternateName: '韩漫在线观看',
  url: 'http://adeled.com/',
  description: '韩漫漫画网站提供韩漫在线观看、免费韩国漫画下拉式阅读体验。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'http://adeled.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const jsonLdOrganization = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '韩漫漫画',
  url: 'http://adeled.com/',
  description: '韩漫漫画 - 免费韩国漫画下拉式在线观看平台',
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '400-888-6666',
    contactType: 'customer service',
    availableLanguage: 'Chinese',
  },
};

const jsonLdFAQ = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '韩漫漫画网站是什么？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '韩漫漫画网站是一个专业的韩国漫画在线观看平台，提供免费韩国漫画下拉式阅读体验，覆盖浪漫爱情、热血动作、奇幻异界等多种类型漫画。',
      },
    },
    {
      '@type': 'Question',
      name: '如何使用下拉式阅读功能？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '进入任意漫画详情页后，您只需向下滚动即可连续阅读，无需点击翻页。下拉式阅读提供流畅无缝的阅读体验，让您沉浸在漫画世界中。',
      },
    },
    {
      '@type': 'Question',
      name: '漫画资源是否免费？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '是的，韩漫漫画网站上的所有韩国漫画资源均为免费提供。您无需注册或付费即可享受全部漫画内容，每日还有200+部漫画同步更新。',
      },
    },
    {
      '@type': 'Question',
      name: '漫画更新频率是多少？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '我们每日极速更新200+部漫画，确保读者能够在第一时间追到最新章节。首页"本周热门更新"模块会实时展示最新更新的漫画作品。',
      },
    },
  ],
};

const jsonLdBreadcrumb = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    {
      '@type': 'ListItem',
      position: 1,
      name: '首页',
      item: 'http://adeled.com/',
    },
  ],
};

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <script type="application/ld+json">{JSON.stringify(jsonLdWebSite)}</script>
        <script type="application/ld+json">{JSON.stringify(jsonLdOrganization)}</script>
        <script type="application/ld+json">{JSON.stringify(jsonLdFAQ)}</script>
        <script type="application/ld+json">{JSON.stringify(jsonLdBreadcrumb)}</script>

        <HeroSection />
        <CategorySection />
        <FeaturedSection />
        <ReviewSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}